import React from "react";
export function ApprovalStatusColumnFormatter(cellContent, row, rowIndex, {updateStatus, superadmin, processing})
{
  const callUpdateStatus = async (row, value) => {
    updateStatus(row.id, value);
  }
 
  if(processing===row.id)
  {
    return (<i className="fas fa-circle-notch fa-spin"></i>)
  }
  else
  {
    if(superadmin)
    {
      return (
        <select
          className="form-control"
          value={row.approval_status}
          onChange={(e) => callUpdateStatus(row, e.target.value)}
        >
          <option value="approved">Approved</option>
          <option value="pending">Pending</option>
          <option value="rejected">Rejected</option>
        </select>
      )
    }
    else
    {
      return(<>{row.approval_status}</>)
    }
  }
}
